import { useSearchParams } from "react-router-dom";
import type { Periodo } from "./api";
import { periodoDaUrl } from "./formato";

/** Período da página na URL (?dias= ou ?inicio=&fim=), mantendo os outros parâmetros. */
export function usePeriodoUrl() {
  const [params, setParams] = useSearchParams();
  const { periodo, dias } = periodoDaUrl(params);

  const definir = (novo: { dias: number } | Periodo) => {
    const p = new URLSearchParams(params);
    p.delete("dias");
    p.delete("inicio");
    p.delete("fim");
    if ("dias" in novo) p.set("dias", String(novo.dias));
    else {
      p.set("inicio", novo.inicio);
      p.set("fim", novo.fim);
    }
    setParams(p, { replace: true });
  };

  return { periodo, dias, definir };
}
